module.exports = __webpack_public_path__ + "static/media/menu20.4f44b093.jpg";